import { QRCodeSVG } from "qrcode.react";
import { Smartphone } from "lucide-react";

/**
 * PwaInstallCard — widget QR code lavanda scuro con testo "Installa l'app · Scansiona col telefono".
 * Props:
 *  - url:   URL da encodare nel QR (default: window.location.origin)
 *  - variant: "wide" (orizzontale, default) | "compact" (verticale, per sidebar)
 */
export default function PwaInstallCard({ url, variant = "wide" }) {
  const target = url || (typeof window !== "undefined" ? window.location.origin : "");
  const isCompact = variant === "compact";

  return (
    <div
      data-testid="pwa-install-card"
      className={`rounded-2xl shadow-lg overflow-hidden bg-gradient-to-br from-[#4c1d95] to-[#6d28d9] text-white ${
        isCompact ? "p-4 flex flex-col items-center gap-3" : "p-6 flex items-center gap-6"
      }`}
    >
      <div className="bg-white p-2 rounded-xl flex-shrink-0" data-testid="pwa-qr-wrap">
        <QRCodeSVG
          value={target}
          size={isCompact ? 128 : 160}
          bgColor="#ffffff"
          fgColor="#0f172a"
          level="M"
          includeMargin={false}
        />
      </div>
      <div className={`min-w-0 ${isCompact ? "text-center" : "flex-1"}`}>
        <div className={`flex items-center gap-2 mb-1.5 ${isCompact ? "justify-center" : ""}`}>
          <Smartphone className="h-5 w-5 text-lavender-200" />
          <span className="text-[10px] uppercase tracking-[0.18em] text-lavender-200 font-semibold">
            IH AuditFlow · PWA
          </span>
        </div>
        <h3 className={`font-display font-semibold tracking-tight ${isCompact ? "text-xl" : "text-2xl md:text-3xl"} leading-tight`}>
          Installa l'app
        </h3>
        <p className={`text-lavender-100 mt-2 ${isCompact ? "text-xs" : "text-sm"}`}>
          Scansiona col telefono per aprire la piattaforma e aggiungerla alla schermata Home in un tap.
        </p>
        {!isCompact && (
          <p className="text-[11px] text-lavender-300 mt-3 truncate font-mono">{target}</p>
        )}
      </div>
    </div>
  );
}
